import {SortSchema} from '@cypro/ui/schemas'
import {AddUserGroupSchema} from '@cypro/engine/mutators'
import * as z from 'zod'

export const UserGroupFormSchema = AddUserGroupSchema.omit({users: true}).extend({
  users: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      firstName: z.string().nullable(),
      lastName: z.string().nullable(),
      username: z.string().nullable(),
    })
  ),
})
export type UserGroupFormSchema = z.infer<typeof UserGroupFormSchema>

export const UserGroupsFiltersSchema = z.object({
  search: z.string().optional(),
})
export type UserGroupsFiltersSchema = z.infer<typeof UserGroupsFiltersSchema>

export const UserGroupsSearchSchema = z.object({
  filters: UserGroupsFiltersSchema.optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]), // supports sorting on multiple columns
})
